// Document Type Module - Initialize immediately
console.log('=== document-type.js script loaded ===');


// Chilean regions and communes data
const chileRegions = {
  'Arica y Parinacota': ['Arica', 'Camarones', 'Putre', 'General Lagos'],
  'Tarapacá': ['Iquique', 'Alto Hospicio', 'Pozo Almonte', 'Camiña', 'Colchane', 'Huara', 'Pica'],
  'Antofagasta': ['Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal', 'Calama', 'Ollagüe', 'San Pedro de Atacama', 'Tocopilla', 'María Elena'],
  'Atacama': ['Copiapó', 'Caldera', 'Tierra Amarilla', 'Chañaral', 'Diego de Almagro', 'Vallenar', 'Alto del Carmen', 'Freirina', 'Huasco'],
  'Coquimbo': ['La Serena', 'Coquimbo', 'Andacollo', 'La Higuera', 'Paiguano', 'Vicuña', 'Illapel', 'Canela', 'Los Vilos', 'Salamanca', 'Ovalle', 'Combarbalá', 'Monte Patria', 'Punitaqui', 'Río Hurtado'],
  'Valparaíso': ['Valparaíso', 'Casablanca', 'Concón', 'Juan Fernández', 'Puchuncaví', 'Quintero', 'Viña del Mar', 'Isla de Pascua', 'Los Andes', 'Calle Larga', 'Rinconada', 'San Esteban', 'La Ligua', 'Cabildo', 'Papudo', 'Petorca', 'Zapallar', 'Quillota', 'Calera', 'Hijuelas', 'La Cruz', 'Nogales', 'San Antonio', 'Algarrobo', 'Cartagena', 'El Quisco', 'El Tabo', 'Santo Domingo', 'San Felipe', 'Catemu', 'Llaillay', 'Panquehue', 'Putaendo', 'Santa María', 'Quilpué', 'Limache', 'Olmué', 'Villa Alemana'],
  'Región Metropolitana': ['Santiago', 'Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón', 'Vitacura', 'Puente Alto', 'Pirque', 'San José de Maipo', 'Colina', 'Lampa', 'Tiltil', 'San Bernardo', 'Buin', 'Calera de Tango', 'Paine', 'Melipilla', 'Alhué', 'Curacaví', 'María Pinto', 'San Pedro', 'Talagante', 'El Monte', 'Isla de Maipo', 'Peñaflor'],
  'O\'Higgins': ['Rancagua', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'Las Cabras', 'Machalí', 'Malloa', 'Mostazal', 'Olivar', 'Peumo', 'Pichidegua', 'Quinta de Tilcoco', 'Rengo', 'Requínoa', 'San Vicente', 'Pichilemu', 'La Estrella', 'Litueche', 'Marchihue', 'Navidad', 'Paredones', 'San Fernando', 'Chépica', 'Chimbarongo', 'Lolol', 'Nancagua', 'Palmilla', 'Peralillo', 'Placilla', 'Pumanque', 'Santa Cruz'],
  'Maule': ['Talca', 'Constitución', 'Curepto', 'Empedrado', 'Maule', 'Pelarco', 'Pencahue', 'Río Claro', 'San Clemente', 'San Rafael', 'Cauquenes', 'Chanco', 'Pelluhue', 'Curicó', 'Hualañé', 'Licantén', 'Molina', 'Rauco', 'Romeral', 'Sagrada Familia', 'Teno', 'Vichuquén', 'Linares', 'Colbún', 'Longaví', 'Parral', 'Retiro', 'San Javier', 'Villa Alegre', 'Yerbas Buenas'],
  'Ñuble': ['Chillán', 'Bulnes', 'Chillán Viejo', 'El Carmen', 'Pemuco', 'Pinto', 'Quillón', 'San Ignacio', 'Yungay', 'Quirihue', 'Cobquecura', 'Coelemu', 'Ninhue', 'Portezuelo', 'Ránquil', 'Treguaco', 'San Carlos', 'Coihueco', 'Ñiquén', 'San Fabián', 'San Nicolás'],
  'Biobío': ['Concepción', 'Coronel', 'Chiguayante', 'Florida', 'Hualqui', 'Lota', 'Penco', 'San Pedro de la Paz', 'Santa Juana', 'Talcahuano', 'Tomé', 'Hualpén', 'Lebu', 'Arauco', 'Cañete', 'Contulmo', 'Curanilahue', 'Los Álamos', 'Tirúa', 'Los Ángeles', 'Antuco', 'Cabrero', 'Laja', 'Mulchén', 'Nacimiento', 'Negrete', 'Quilaco', 'Quilleco', 'San Rosendo', 'Santa Bárbara', 'Tucapel', 'Yumbel', 'Alto Biobío'],
  'Araucanía': ['Temuco', 'Carahue', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica', 'Cholchol', 'Angol', 'Collipulli', 'Curacautín', 'Ercilla', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Purén', 'Renaico', 'Traiguén', 'Victoria'],
  'Los Ríos': ['Valdivia', 'Corral', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'La Unión', 'Futrono', 'Lago Ranco', 'Río Bueno'],
  'Los Lagos': ['Puerto Montt', 'Calbuco', 'Cochamó', 'Fresia', 'Frutillar', 'Los Muermos', 'Llanquihue', 'Maullín', 'Puerto Varas', 'Castro', 'Ancud', 'Chonchi', 'Curaco de Vélez', 'Dalcahue', 'Puqueldón', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Osorno', 'Puerto Octay', 'Purranque', 'Puyehue', 'Río Negro', 'San Juan de la Costa', 'San Pablo', 'Chaitén', 'Futaleufú', 'Hualaihué', 'Palena'],
  'Aysén': ['Coyhaique', 'Lago Verde', 'Aysén', 'Cisnes', 'Guaitecas', 'Chile Chico', 'Río Ibáñez', 'Cochrane', 'O\'Higgins', 'Tortel', 'Puerto Natales', 'Torres del Paine'],
  'Magallanes': ['Punta Arenas', 'Laguna Blanca', 'Río Verde', 'San Gregorio', 'Porvenir', 'Primavera', 'Timaukel', 'Natales', 'Torres del Paine', 'Cabo de Hornos', 'Antártica'],
  'Región de la Araucanía': ['Temuco', 'Carahue', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica', 'Cholchol', 'Angol', 'Collipulli', 'Curacautín', 'Ercilla', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Purén', 'Renaico', 'Traiguén', 'Victoria']
};

class DocumentType extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    console.log('DocumentType connectedCallback called');
    // Use a small delay to ensure DOM is fully ready
    setTimeout(() => {
      if (!this.initialized) {
        console.log('Initializing DocumentType element');
        this.init();
        this.initialized = true;
      }
    }, 50);
  }

  init() {
    console.log('=== DocumentType.init() called ===');
    console.log('Element:', this);
    console.log('Element HTML:', this.outerHTML.substring(0, 200));
    
    // Try both name formats for compatibility
    const radioButtons = this.querySelectorAll('input[type="radio"][name="document_type"], input[type="radio"][name="attributes[document_type]"]');
    console.log("Found radio buttons:", radioButtons.length);
    console.log("Radio buttons:", Array.from(radioButtons).map(r => ({ id: r.id, name: r.name, value: r.value })));
    
    if (radioButtons.length === 0) {
      console.log('No radio buttons found, retrying in 100ms...');
      // Elements not ready yet, try again
      setTimeout(() => this.init(), 100);
      return;
    }
    
    // Set initial state based on saved value
    const savedType = this.dataset.savedType || 'boleta';
    const savedRadio = this.querySelector(`input[value="${savedType}"]`);
    if (savedRadio) {
      savedRadio.checked = true;
      this.toggleForm(savedType === 'factura');
    }

    // Handle radio button changes - attach directly to each radio button
    radioButtons.forEach(radio => {
      // Remove existing listeners to avoid duplicates
      const newRadio = radio.cloneNode(true);
      radio.parentNode.replaceChild(newRadio, radio);
      
      newRadio.addEventListener('change', (event) => {
        const selectedType = event.target.value;
        console.log('Document type changed to:', selectedType);
        this.toggleForm(selectedType === 'factura');
        this.updateCartAttribute('document_type', selectedType);
        
        // Clear factura data if switching to boleta
        if (selectedType === 'boleta') {
          // First clear form inputs
          this.clearFacturaFormInputs();
          // Then clear cart attributes
          this.clearFacturaData();
          // Enable checkout button
          this.enableCheckoutButton();
          console.log('Switched to boleta - all factura data cleared');
        } else {
          // Validate when switching to factura
          setTimeout(() => {
            this.validateAllFields();
          }, 100);
        }
      });
    });

    // Initialize region and commune dropdowns
    this.initRegionDropdown();
    this.initCommuneDropdown();
    
    // Handle form field changes
    this.initFormFields();
  }

  toggleForm(show) {
    const facturaForm = this.querySelector('.factura-form');
    if (!facturaForm) {
      console.warn('factura-form element not found in', this);
      return;
    }
    
    console.log('toggleForm called with show:', show);
    
    if (show) {
      facturaForm.style.display = 'block';
      facturaForm.classList.add('factura-form--visible');
      facturaForm.classList.remove('factura-form--hidden');
      facturaForm.removeAttribute('hidden');
      console.log('Form should be visible now');
    } else {
      facturaForm.style.display = 'none';
      facturaForm.classList.add('factura-form--hidden');
      facturaForm.classList.remove('factura-form--visible');
      facturaForm.setAttribute('hidden', '');
      console.log('Form should be hidden now');
    }
  }

  initRegionDropdown() {
    const regionSelect = this.querySelector('#factura-region, #mini-cart-factura-region');
    if (!regionSelect) return;

    // Populate regions
    Object.keys(chileRegions).forEach(region => {
      const option = document.createElement('option');
      option.value = region;
      option.textContent = region;
      regionSelect.appendChild(option);
    });

    // Set saved value if exists
    const savedRegion = this.dataset.savedRegion;
    if (savedRegion && savedRegion !== '') {
      regionSelect.value = savedRegion;
      this.updateCommunes(savedRegion, this.dataset.savedComuna);
    }
  }

  initCommuneDropdown() {
    const communeSelect = this.querySelector('#factura-comuna, #mini-cart-factura-comuna');
    if (!communeSelect) return;

    // Handle commune change
    communeSelect.addEventListener('change', (event) => {
      this.updateCartAttribute('Comuna', event.target.value);
    });
  }

  updateCommunes(region, savedCommune = null) {
    const communeSelect = this.querySelector('#factura-comuna, #mini-cart-factura-comuna');
    if (!communeSelect) return;

    // Clear existing options except the first one
    communeSelect.innerHTML = '<option value="">Selecciona una comuna</option>';

    // Add communes for selected region
    const communes = chileRegions[region] || [];
    communes.forEach(commune => {
      const option = document.createElement('option');
      option.value = commune;
      option.textContent = commune;
      if (savedCommune && savedCommune === commune) {
        option.selected = true;
      }
      communeSelect.appendChild(option);
    });
  }

  validateAllFields() {
    const isFactura = this.querySelector('input[value="factura"]:checked') !== null;
    
    if (!isFactura) {
      // If not factura, enable checkout button
      this.enableCheckoutButton();
      return true;
    }

    const rutInput = this.querySelector('#factura-rut, #mini-cart-factura-rut');
    const giroInput = this.querySelector('#factura-giro, #mini-cart-factura-giro');
    const razonSocialInput = this.querySelector('#factura-razon-social, #mini-cart-factura-razon-social');
    const direccionInput = this.querySelector('#factura-direccion, #mini-cart-factura-direccion');
    const emailInput = this.querySelector('#factura-email, #mini-cart-factura-email');
    const regionSelect = this.querySelector('#factura-region, #mini-cart-factura-region');
    const communeSelect = this.querySelector('#factura-comuna, #mini-cart-factura-comuna');

    // Validate RUT - must be filled and valid when factura is selected
    const rutValue = rutInput?.value.trim() || '';
    const rutValid = rutValue !== '' && validateRUT(rutValue);
    if (rutInput) {
      if (rutValue !== '' && !rutValid) {
        rutInput.classList.add('invalid');
      } else if (rutValid) {
        rutInput.classList.remove('invalid');
      }
    }

    // Validate email - must be filled and valid when factura is selected
    const emailValue = emailInput?.value.trim() || '';
    const emailValid = emailValue !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    if (emailInput) {
      if (emailValue !== '' && !emailValid) {
        emailInput.classList.add('invalid');
      } else if (emailValid) {
        emailInput.classList.remove('invalid');
      }
    }

    // Check all required fields are filled
    const allFieldsFilled = 
      rutValue !== '' &&
      rutValid &&
      (giroInput?.value.trim() || '') !== '' &&
      (razonSocialInput?.value.trim() || '') !== '' &&
      (direccionInput?.value.trim() || '') !== '' &&
      (regionSelect?.value || '') !== '' &&
      (communeSelect?.value || '') !== '' &&
      emailValue !== '' &&
      emailValid;

    if (allFieldsFilled) {
      this.enableCheckoutButton();
      return true;
    } else {
      this.disableCheckoutButton();
      return false;
    }
  }

  enableCheckoutButton() {
    // Find checkout button - try multiple selectors
    const selectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'form#cart button[name="checkout"]',
      '.button-container button[name="checkout"]',
      '.mini-cart button[name="checkout"]'
    ];
    
    let checkoutButton = null;
    for (const selector of selectors) {
      checkoutButton = document.querySelector(selector);
      if (checkoutButton) break;
    }
    
    if (checkoutButton) {
      checkoutButton.removeAttribute('disabled');
      checkoutButton.classList.remove('disabled');
      console.log('Checkout button enabled');
    } else {
      console.warn('Checkout button not found with selectors:', selectors);
    }
  }

  disableCheckoutButton() {
    // Find checkout button - try multiple selectors
    const selectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'form#cart button[name="checkout"]',
      '.button-container button[name="checkout"]',
      '.mini-cart button[name="checkout"]'
    ];
    
    let checkoutButton = null;
    for (const selector of selectors) {
      checkoutButton = document.querySelector(selector);
      if (checkoutButton) break;
    }
    
    if (checkoutButton) {
      checkoutButton.setAttribute('disabled', 'disabled');
      checkoutButton.classList.add('disabled');
      console.log('Checkout button disabled - form validation failed');
    } else {
      console.warn('Checkout button not found with selectors:', selectors);
    }
  }

  initFormFields() {
    const rutInput = this.querySelector('#factura-rut, #mini-cart-factura-rut');
    const giroInput = this.querySelector('#factura-giro, #mini-cart-factura-giro');
    const razonSocialInput = this.querySelector('#factura-razon-social, #mini-cart-factura-razon-social');
    const direccionInput = this.querySelector('#factura-direccion, #mini-cart-factura-direccion');
    const emailInput = this.querySelector('#factura-email, #mini-cart-factura-email');
    const regionSelect = this.querySelector('#factura-region, #mini-cart-factura-region');

    // Set saved values
    if (rutInput && this.dataset.savedRut) {
      rutInput.value = this.dataset.savedRut;
    }
    if (giroInput && this.dataset.savedGiro) {
      giroInput.value = this.dataset.savedGiro;
    }
    if (razonSocialInput && this.dataset.savedRazonSocial) {
      razonSocialInput.value = this.dataset.savedRazonSocial;
    }
    if (direccionInput && this.dataset.savedDireccion) {
      direccionInput.value = this.dataset.savedDireccion;
    }
    if (emailInput && this.dataset.savedEmail) {
      emailInput.value = this.dataset.savedEmail;
    }

    // Handle RUT input with validation
    if (rutInput) {
      // Format RUT as user types
      rutInput.addEventListener('input', (event) => {
        const value = event.target.value;
        const cursorPosition = event.target.selectionStart;
        
        // Format the RUT
        const formatted = formatRUT(value);
        if (formatted !== value) {
          event.target.value = formatted;
          // Restore cursor position
          const newPosition = Math.min(cursorPosition + (formatted.length - value.length), formatted.length);
          event.target.setSelectionRange(newPosition, newPosition);
        }
      });
      
      // Validate RUT on blur or after typing
      const validateRUTInput = debounce((event) => {
        const value = event.target.value.trim();
        const fieldContainer = event.target.closest('.field');
        let errorMessage = fieldContainer?.querySelector('.rut-error-message');
        
        if (value === '') {
          // Clear error if field is empty
          if (errorMessage) {
            errorMessage.remove();
          }
          event.target.classList.remove('invalid');
          this.updateCartAttribute('RUTEmpresa', '');
          return;
        }
        
        const isValid = validateRUT(value);
        
        if (!isValid) {
          // Show error message
          if (!errorMessage) {
            errorMessage = document.createElement('span');
            errorMessage.className = 'rut-error-message';
            errorMessage.style.cssText = 'display: block; color: var(--color-critical, #d72c0d); font-size: 1.2rem; margin-top: 0.5rem;';
            fieldContainer.appendChild(errorMessage);
          }
          errorMessage.textContent = 'RUT inválido. Por favor ingrese un RUT válido (ej: 12.345.678-9)';
          event.target.classList.add('invalid');
        } else {
          // Remove error message
          if (errorMessage) {
            errorMessage.remove();
          }
          event.target.classList.remove('invalid');
          this.updateCartAttribute('RUTEmpresa', value);
        }
      }, 500);
      
      rutInput.addEventListener('blur', validateRUTInput);
      rutInput.addEventListener('input', validateRUTInput);
      
      // Validate all fields after RUT validation
      rutInput.addEventListener('blur', () => {
        setTimeout(() => this.validateAllFields(), 100);
      });
      rutInput.addEventListener('input', debounce(() => {
        this.validateAllFields();
      }, 500));
    }

    // Handle email validation
    if (emailInput) {
      emailInput.addEventListener('blur', () => {
        const value = emailInput.value.trim();
        const fieldContainer = emailInput.closest('.field');
        let errorMessage = fieldContainer?.querySelector('.email-error-message');
        
        if (value === '') {
          if (errorMessage) {
            errorMessage.remove();
          }
          emailInput.classList.remove('invalid');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          if (!errorMessage) {
            errorMessage = document.createElement('span');
            errorMessage.className = 'email-error-message';
            errorMessage.style.cssText = 'display: block; color: var(--color-critical, #d72c0d); font-size: 1.2rem; margin-top: 0.5rem;';
            fieldContainer.appendChild(errorMessage);
          }
          errorMessage.textContent = 'Por favor ingrese un correo electrónico válido';
          emailInput.classList.add('invalid');
        } else {
          if (errorMessage) {
            errorMessage.remove();
          }
          emailInput.classList.remove('invalid');
        }
        this.validateAllFields();
      });
    }

    // Handle other input changes with debounce
    [giroInput, razonSocialInput, direccionInput, emailInput].forEach(input => {
      if (input) {
        input.addEventListener('input', debounce((event) => {
          const fieldId = event.target.id.replace('factura-', '').replace('mini-cart-factura-', '');
          let attributeName;
          
          // Map field IDs to cart attribute names
          if (fieldId === 'giro') {
            attributeName = 'Giro';
          } else if (fieldId === 'razon-social') {
            attributeName = 'RazonSocial';
          } else if (fieldId === 'direccion') {
            attributeName = 'DireccionEmpresa';
          } else if (fieldId === 'email') {
            attributeName = 'Correo Electrónico';
          }
          
          if (attributeName) {
            this.updateCartAttribute(attributeName, event.target.value);
          }
          
          // Validate all fields after input
          this.validateAllFields();
        }, 300));
      }
    });

    // Handle region change
    if (regionSelect) {
      regionSelect.addEventListener('change', (event) => {
        this.updateCommunes(event.target.value);
        this.updateCartAttribute('Región', event.target.value);
        // Clear commune when region changes
        this.updateCartAttribute('Comuna', '');
        this.validateAllFields();
      });
    }

    // Handle commune change
    const communeSelect = this.querySelector('#factura-comuna, #mini-cart-factura-comuna');
    if (communeSelect) {
      communeSelect.addEventListener('change', () => {
        this.validateAllFields();
      });
    }

    // Initial validation after all fields are initialized
    setTimeout(() => {
      this.validateAllFields();
    }, 500);
  }

  updateCartAttribute(key, value) {
    const body = JSON.stringify({ 
      attributes: { [key]: value } 
    });
    
    fetch(`${theme.routes.cart_update_url}`, {
      ...fetchConfig(), 
      ...{ body }
    }).catch((e) => {
      console.error(e);
    });
  }

  clearFacturaFormInputs() {
    // Clear all input values
    const rutInput = this.querySelector('#factura-rut, #mini-cart-factura-rut');
    const giroInput = this.querySelector('#factura-giro, #mini-cart-factura-giro');
    const razonSocialInput = this.querySelector('#factura-razon-social, #mini-cart-factura-razon-social');
    const direccionInput = this.querySelector('#factura-direccion, #mini-cart-factura-direccion');
    const emailInput = this.querySelector('#factura-email, #mini-cart-factura-email');
    const regionSelect = this.querySelector('#factura-region, #mini-cart-factura-region');
    const communeSelect = this.querySelector('#factura-comuna, #mini-cart-factura-comuna');

    if (rutInput) {
      rutInput.value = '';
      rutInput.classList.remove('invalid');
      const rutError = rutInput.closest('.field')?.querySelector('.rut-error-message');
      if (rutError) rutError.remove();
    }

    if (giroInput) {
      giroInput.value = '';
      giroInput.classList.remove('invalid');
    }

    if (razonSocialInput) {
      razonSocialInput.value = '';
      razonSocialInput.classList.remove('invalid');
    }

    if (direccionInput) {
      direccionInput.value = '';
      direccionInput.classList.remove('invalid');
    }

    if (emailInput) {
      emailInput.value = '';
      emailInput.classList.remove('invalid');
      const emailError = emailInput.closest('.field')?.querySelector('.email-error-message');
      if (emailError) emailError.remove();
    }

    if (regionSelect) {
      regionSelect.value = '';
    }

    if (communeSelect) {
      communeSelect.innerHTML = '<option value="">Selecciona una comuna</option>';
    }
  }

  clearFacturaData() {
    console.log('Clearing factura data from cart attributes...');
    const attributes = {
      'RUTEmpresa': '',
      'Giro': '',
      'RazonSocial': '',
      'DireccionEmpresa': '',
      'Región': '',
      'Comuna': '',
      'Correo Electrónico': ''
    };

    const body = JSON.stringify({ attributes });
    
    fetch(`${theme.routes.cart_update_url}`, {
      ...fetchConfig(), 
      ...{ body }
    })
    .then((response) => response.json())
    .then((data) => {
      console.log('Factura data cleared from cart attributes');
      // Optionally update the cart UI if needed
      if (data.sections) {
        // Update sections if provided in response
        Object.keys(data.sections).forEach((sectionId) => {
          const sectionElement = document.getElementById(sectionId);
          if (sectionElement) {
            const sectionHTML = data.sections[sectionId];
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHTML, 'text/html');
            const newContent = doc.querySelector(`#${sectionId}, .shopify-section`)?.innerHTML;
            if (newContent) {
              sectionElement.innerHTML = newContent;
            }
          }
        });
      }
    })
    .catch((e) => {
      console.error('Error clearing factura data:', e);
    });
  }
}

customElements.define('document-type', DocumentType);

// Function to initialize all document-type elements
function initializeAllDocumentTypes() {
  console.log('initializeAllDocumentTypes called');
  const documentTypes = document.querySelectorAll('document-type');
  console.log('Found', documentTypes.length, 'document-type elements');
  
  documentTypes.forEach((element, index) => {
    if (element.isConnected) {
      console.log(`Initializing document-type element ${index}`);
      // Force re-initialization for dynamically loaded content
      element.initialized = false;
      try {
        element.init();
        element.initialized = true;
        console.log(`Document-type element ${index} initialized successfully`);
      } catch (error) {
        console.error(`Error initializing document-type element ${index}:`, error);
      }
    } else {
      console.log(`Document-type element ${index} is not connected to DOM`);
    }
  });
}

// Function to force upgrade custom elements after innerHTML insertion
function upgradeCustomElements(container) {
  const documentTypes = container.querySelectorAll('document-type');
  console.log('upgradeCustomElements: Found', documentTypes.length, 'document-type elements');
  
  documentTypes.forEach((element, index) => {
    console.log(`Upgrading document-type element ${index}`);
    // Force re-initialization
    if (element.isConnected) {
      element.initialized = false;
      try {
        element.init();
        element.initialized = true;
        console.log(`Document-type element ${index} upgraded successfully`);
      } catch (error) {
        console.error(`Error upgrading document-type element ${index}:`, error);
      }
    }
  });
}

// Simple polling approach to check for document-type elements in mini-cart
function checkAndInitializeMiniCart() {
  const miniCartContainer = document.getElementById('mini-cart');
  if (!miniCartContainer) {
    console.log('Mini-cart container not found');
    return;
  }

  const documentTypes = miniCartContainer.querySelectorAll('document-type');
  console.log('checkAndInitializeMiniCart: Found', documentTypes.length, 'document-type elements in mini-cart');
  
  if (documentTypes.length > 0) {
    documentTypes.forEach((element, index) => {
      console.log(`Checking document-type element ${index}:`, {
        isConnected: element.isConnected,
        initialized: element.initialized,
        hasInit: typeof element.init === 'function'
      });
      
      if (element.isConnected && !element.initialized) {
        console.log(`Initializing document-type element ${index}...`);
        try {
          element.init();
          element.initialized = true;
          console.log(`✓ Document-type element ${index} initialized successfully`);
        } catch (error) {
          console.error(`✗ Error initializing document-type element ${index}:`, error);
        }
      } else if (element.isConnected && element.initialized) {
        console.log(`Document-type element ${index} already initialized`);
      }
    });
  }
}

// Re-initialize document-type elements when cart drawer opens (for dynamic content)
document.addEventListener('cartdrawer:opened', () => {
  console.log('=== Cart drawer opened event fired ===');
  
  // Try multiple times with increasing delays
  [50, 150, 300, 500, 800, 1200].forEach((delay, index) => {
    setTimeout(() => {
      console.log(`[Attempt ${index + 1}] Checking for document-type elements (delay: ${delay}ms)`);
      checkAndInitializeMiniCart();
      initializeAllDocumentTypes();
    }, delay);
  });
});

// Also listen for cart updates
document.addEventListener('cart:updated', () => {
  console.log('=== Cart updated event fired ===');
  setTimeout(() => {
    checkAndInitializeMiniCart();
    initializeAllDocumentTypes();
  }, 200);
});

// Poll every second to catch any missed initializations (as fallback)
let pollInterval = setInterval(() => {
  const miniCart = document.getElementById('mini-cart');
  if (miniCart && miniCart.querySelector('document-type')) {
    console.log('Polling: Found document-type in mini-cart, initializing...');
    checkAndInitializeMiniCart();
  }
}, 1000);

// Stop polling after 30 seconds to avoid performance issues
setTimeout(() => {
  clearInterval(pollInterval);
  console.log('Stopped polling for document-type elements');
}, 30000);

// Also listen for when mini-cart content is updated
document.addEventListener('ajaxProduct:added', () => {
  setTimeout(initializeAllDocumentTypes, 400);
});

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initializeAllDocumentTypes, 200);
  });
} else {
  setTimeout(initializeAllDocumentTypes, 200);
}

// Use MutationObserver to watch for dynamically added document-type elements
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // Element node
        // Check if the node itself is a document-type element
        if (node.tagName && node.tagName.toLowerCase() === 'document-type') {
          setTimeout(() => {
            if (node.isConnected) {
              console.log('MutationObserver: Found document-type element, initializing...');
              node.initialized = false;
              node.init();
              node.initialized = true;
            }
          }, 150);
        }
        // Check for document-type elements inside the added node
        if (node.querySelectorAll) {
          const documentTypes = node.querySelectorAll('document-type');
          if (documentTypes.length > 0) {
            console.log('MutationObserver: Found', documentTypes.length, 'document-type elements inside added node');
            documentTypes.forEach((element, index) => {
              if (element.isConnected) {
                setTimeout(() => {
                  console.log(`MutationObserver: Initializing document-type element ${index}`);
                  element.initialized = false;
                  element.init();
                  element.initialized = true;
                }, 150);
              }
            });
          }
        }
      }
    });
  });
});

// Start observing - watch for changes in the mini-cart container specifically
let miniCartContainer = document.getElementById('mini-cart');
if (miniCartContainer) {
  observer.observe(miniCartContainer, {
    childList: true,
    subtree: true
  });
  console.log('Observing mini-cart container for changes');
} else {
  // Wait for mini-cart to be created
  const miniCartObserver = new MutationObserver(() => {
    miniCartContainer = document.getElementById('mini-cart');
    if (miniCartContainer) {
      observer.observe(miniCartContainer, {
        childList: true,
        subtree: true
      });
      console.log('Found mini-cart container, now observing');
      miniCartObserver.disconnect();
    }
  });
  miniCartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Also observe the entire body as fallback
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// RUT validation function (Chilean RUT)
function validateRUT(rut) {
  // Remove dots and dashes, convert to uppercase
  rut = rut.replace(/\./g, '').replace(/-/g, '').toUpperCase().trim();
  
  // Check format: at least 7 digits + 1 character (digit or K)
  if (!/^\d{7,8}[0-9K]$/.test(rut)) {
    return false;
  }
  
  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);
  
  // Calculate verification digit
  let sum = 0;
  let multiplier = 2;
  
  // Process digits from right to left
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  
  const remainder = sum % 11;
  let calculatedDV = 11 - remainder;
  
  if (calculatedDV === 11) {
    calculatedDV = '0';
  } else if (calculatedDV === 10) {
    calculatedDV = 'K';
  } else {
    calculatedDV = calculatedDV.toString();
  }
  
  return calculatedDV === dv;
}

// Format RUT with dots and dash
function formatRUT(rut) {
  // Remove all non-digit and non-K characters
  rut = rut.replace(/[^0-9Kk]/g, '').toUpperCase();
  
  if (rut.length === 0) return '';
  
  // Separate body and DV
  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);
  
  // Add dots every 3 digits from right to left
  let formattedBody = '';
  for (let i = body.length - 1; i >= 0; i--) {
    formattedBody = body[i] + formattedBody;
    if ((body.length - i) % 3 === 0 && i > 0) {
      formattedBody = '.' + formattedBody;
    }
  }
  
  return formattedBody + '-' + dv;
}

// Debounce helper function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}